import { Modal } from 'antd';

export const BaseCustomModal = ({
  title,
  isModalOpen,
  handleOk,
  handleCancel,
  children,
  ...props
}) => {
  return (
    <Modal
      title={title}
      open={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      zIndex={props.zIndex ?? 1050}
      {...props}
    >
      {children ?? <div>Sin componente</div>}
    </Modal>
  );
};